(() => {
  if (customElements.get('milwaukee-community')) return;
  customElements.define('milwaukee-community', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.mw-community__track');
      this.cards = [...this.querySelectorAll('.mw-community__card')];
      this.controls = this.querySelector('.mw-community__controls');
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-index]');
        const arrow = event.target.closest('[data-step]');
        if (dot || arrow) this.go(dot ? Number(dot.dataset.index) : this.index + Number(arrow.dataset.step));
      }, options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      document.addEventListener('shopify:block:select', event => {
        const i = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (i >= 0) this.go(i);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      this.stride = this.cards.length ? this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0) : 1;
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.maxIndex = Math.max(0, Math.ceil((this.max - 2) / this.stride));
      this.index = this.track.scrollLeft >= this.max - 2 ? this.maxIndex : Math.round(this.track.scrollLeft / this.stride);
      this.controls.hidden = this.max < 2;
      this.querySelector('[data-step="-1"]').disabled = this.track.scrollLeft <= 2;
      this.querySelector('[data-step="1"]').disabled = this.track.scrollLeft >= this.max - 2;
      this.dots.forEach((dot, i) => { dot.hidden = i > this.maxIndex; dot.setAttribute('aria-pressed', String(i === this.index)); });
    }
    go(index) {
      const left = Math.min(this.max, Math.max(0, index * this.stride));
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() { this.controller.abort(); this.observer.disconnect(); }
  });
})();
